import { ActivitiesDoneToday } from "../components/ActivitiesDoneToday/ActivitiesDoneToday";
import { AdvancedSearch } from "../components/AdvancedSearch/AdvancedSearch";
import { AllActivities } from "../components/AllActivities/AllActivities";
import { ClueWithoutActivity } from "../components/ClueWithoutActivity/ClueWithoutActivity";
import CrmChart from "../components/CrmChart/CrmChart";
import CrmChartAppUse from "../components/CrmChartAppUse/CrmChartAppUse";
import { CustomersWithoutActivity } from "../components/CustomersWithoutActivity/CustomersWithoutActivity";
import DeletedFiles from "../components/DeletedFiles/DeletedFiles";
import { FirstFiles } from "../components/FirstFiles/FirstFiles";
import Grouping from "../components/Grouping/Grouping";
import { InvoicelessCustomers } from "../components/InvoicelessCustomers/InvoicelessCustomers";
import OnlineChat from "../components/OnlineChat/OnlineChat";
import { PassedActivities } from "../components/PassedActivities/PassedActivities";
import { TodayActivities } from "../components/TodayActivities/TodayActivities";
import { TransactionsBasedOnPersons } from "../components/TransactionsBasedOnPersons/TransactionsBasedOnPersons";
import UrlInserter from "../components/UrlInserter/UrlInserter";
import UsersList from "../components/UsersList/UsersList";
import CrmMarker from "../pages/CrmMarker/CrmMarker";
import { CustomerFile } from "../pages/CustomerFile/CustomerFile";
import { DashboardCrm } from "../pages/DashboardCrm/DashboardCrm";
import { Reporting } from "../pages/Reporting/Reporting";
import Tags from "../pages/Tags/Tags";
import { TradingList } from "../pages/TradingList/TradingList";

export const CrmRoute = [
  {
    path: "/",
    className: "dashboard",
    component: <DashboardCrm />,
  },
  {
    path: "/customer-file/:id",
    className: "orders",
    component: <CustomerFile />,
  },
  {
    path: "/tradinglist",
    className: "tradinglist",
    component: <TradingList />,
  },
  {
    path: "/advancedsearch",
    className: "advancedsearch",
    component: <AdvancedSearch />,
  },
  {
    path: "/reporting",
    className: "reporting",
    component: <Reporting />,
  },
  {
    path: "/reporting/Invoicelesscustomers",
    className: "Invoicelesscustomers",
    component: <InvoicelessCustomers />,
  },
  {
    path: "/reporting/marker",
    className: "marker",
    component: <CrmMarker />,
  },
  {
    path: "/reporting/Transactionsbasedonpersons",
    className: "Transactionsbasedonpersons",
    component: <TransactionsBasedOnPersons />,
  },
  {
    path: "/reporting/tradinglist",
    className: "tradinglist",
    component: <TradingList />,
  },
  {
    path: "/reporting/todayactivities",
    className: "todayactivities",
    component: <TodayActivities />,
  },

  {
    path: "/reporting/activitiesdonetoday",
    className: "userswithoutactivity",
    component: <ActivitiesDoneToday />,
  },
  {
    path: "/reporting/firstfiles",
    className: "userswithoutactivity",
    component: <FirstFiles />,
  },
  {
    path: "/reporting/allActivityAndChances",
    className: "allActivityAndChances",
    component: <AllActivities />,
  },
  {
    path: "/reporting/passedActivities",
    className: "passedActivities",
    component: <PassedActivities />,
  },
  {
    path: "/reporting/CluesWithoutActivity",
    className: "cluesWithoutActivity",
    component: <ClueWithoutActivity />,
  },
  {
    path: "/reporting/CustomersWithoutActivity",
    className: "CustomersWithoutActivity",
    component: <CustomersWithoutActivity />,
  },
  {
    path: "/reporting/DeletedFiles",
    className: "DeletedFiles",
    component: <DeletedFiles />,
  },
  {
    path: "/reporting/UsersList",
    className: "UsersList",
    component: <UsersList />,
  },
  {
    path: "/OnlineChat",
    className: "OnlineChat",
    component: <OnlineChat />,
  },
  {
    path: "/Chart",
    className: "chart",
    component: <CrmChart />,
  },
  {
    path: "/ChartApp",
    className: "chart",
    component: <CrmChartAppUse />,
  },
  {
    path: "/tags",
    className: "tags",
    component: <Tags />,
  },
  {
    path: "/grouping",
    className: "grouping",
    component: <Grouping />,
  },
  {
    path: "/urlInserter",
    className: "urlInserter",
    component: <UrlInserter />,
  },
];
